import React from 'react'
import {
  QueryClientProvider,
  QueryClient,
  useQuery,
} from '@tanstack/react-query'
import { apiGet } from '~/util/api'
import { TranslationProvider } from '~/components/shared/TranslationProvider'
import translations from './locales.json'
import UpdateCandidateProfileDialog from './UpdateCandidateProfileDialog'
import { Toaster } from '~/lib/ui/toast'

const queryClient = new QueryClient()

const UpdateCandidateProfile = ({
  children,
  selectProgram,
  showUpdateProfileDialog,
  toggleShowUpdateProfileDialog,
}) => {
  return (
    <QueryClientProvider client={queryClient}>
      <DataLayer
        selectProgram={selectProgram}
        showUpdateProfileDialog={showUpdateProfileDialog}
        toggleShowUpdateProfileDialog={toggleShowUpdateProfileDialog}
      >
        {children}
      </DataLayer>
      <Toaster />
    </QueryClientProvider>
  )
}

const DataLayer = ({
  children,
  selectProgram,
  showUpdateProfileDialog,
  toggleShowUpdateProfileDialog,
}) => {
  const queryFn = () =>
    apiGet('/candidate_profiles.json').then((res) => res.data)

  const { data, isLoading } = useQuery({
    queryKey: ['candidateProfile'],
    queryFn,
  })

  if (isLoading) return null

  const serviceStatus = data.service_status

  if (!['liaison', 'liaison_noinfo'].includes(serviceStatus) && !selectProgram)
    return null

  return (
    <>
      <TranslationProvider
        locale={data.locale}
        translations={translations}
        scope="javascript.components.UpdateCandidateProfile"
      >
        {children}
        <UpdateCandidateProfileDialog
          data={data}
          showUpdateProfileDialog={showUpdateProfileDialog}
          toggleShowUpdateProfileDialog={toggleShowUpdateProfileDialog}
        />
      </TranslationProvider>
    </>
  )
}

export default UpdateCandidateProfile
